module.exports = __webpack_public_path__ + "img/left-door.0d81b379.png";